"use strict";

var _regeneratorRuntime = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(flatten);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function flatten(arrays) {
  var _iterator, _step, array;

  return _regeneratorRuntime.wrap(function flatten$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _iterator = _createForOfIteratorHelper(arrays);
        _context.prev = 1;

        _iterator.s();

      case 3:
        if ((_step = _iterator.n()).done) {
          _context.next = 8;
          break;
        }

        array = _step.value;
        return _context.delegateYield(array, "t0", 6);

      case 6:
        _context.next = 3;
        break;

      case 8:
        _context.next = 13;
        break;

      case 10:
        _context.prev = 10;
        _context.t1 = _context["catch"](1);

        _iterator.e(_context.t1);

      case 13:
        _context.prev = 13;

        _iterator.f();

        return _context.finish(13);

      case 16:
      case "end":
        return _context.stop();
    }
  }, _marked, null, [[1, 10, 13, 16]]);
}

function merge(arrays) {
  return Array.from(flatten(arrays));
}